import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Lock, Handshake, ShieldCheck } from 'lucide-react';
const advantages = [{
  icon: Scale,
  title: 'Експертність',
  description: 'Глибоке знання законодавства та успішна судова практика.'
}, {
  icon: Lock,
  title: 'Конфіденційність',
  description: 'Суворе дотримання адвокатської таємниці. Ваші дані під захистом.'
}, {
  icon: Handshake,
  title: 'Прозорість',
  description: 'Реальна оцінка перспектив та узгоджена вартість без прихованих платежів.'
}, {
  icon: ShieldCheck,
  title: 'Результат',
  description: 'Розробка дієвої стратегії та доведення справи до логічного завершення.'
}];
export function Advantages() {
  return <section className="py-24 px-6 bg-white border-t border-zinc-100" data-id="element-8">
      <div className="max-w-6xl mx-auto" data-id="element-9">
        <div className="mb-16 md:mb-24" data-id="element-10">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-zinc-900 mb-6" data-id="element-11">
            Принципи роботи
          </h2>
          <p className="text-zinc-500 text-lg max-w-xl font-light" data-id="element-12">
            Професійний підхід, заснований на чесності, конфіденційності та
            націленості на результат.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8" data-id="element-13">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col" data-id="element-14">
              <div className="w-12 h-12 rounded-2xl bg-zinc-50 border border-zinc-100 flex items-center justify-center mb-6" data-id="element-15">
                <adv.icon className="w-5 h-5 text-zinc-700" strokeWidth={1.5} data-id="element-16" />
              </div>
              <h3 className="text-xl font-medium text-zinc-900 mb-3" data-id="element-17">
                {adv.title}
              </h3>
              <p className="text-zinc-500 leading-relaxed font-light text-sm" data-id="element-18">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}